export default {
  BOX: 'box',
};

